import App from "../Core/App";
import BaseComponent from "./BaseComponent";

export default class TableComponent extends BaseComponent {
    constructor() {
        super();

        let app = App.getInstance(),
            em  = app.getEventManager();

         if( $('table.blb-table').length > 0 ) {
            let script = document.createElement('script');
            script.id = 'hypen_load';
            script.src = app.getPublicPath() + '/Resources/Public/Hyphenopoly_Loader.js';
            document.head.appendChild(script);
        }
    }
}